import script from "./team.vue?vue&type=script&setup=true&lang=js"
export * from "./team.vue?vue&type=script&setup=true&lang=js"

import "./team.vue?vue&type=style&index=0&id=131c4239&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131c4239"]])

export default __exports__